export default "__VITE_ASSET__d65295c4__"